import { FilterMemberSearchPipe } from './pipes/member-search.pipe';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { RouterModule } from '@angular/router';
import { SlotComponent } from './slot/slot.component';
import { FilterPipe } from './pipes/filter.pipe';
import { FilterMeetingHostPipe } from './pipes/meetingHost.pipe';
import { FilterMeetingRoomPipe } from './pipes/meetingRoom.pipe';
import { SlotDetailComponent } from './slot-detail/slot-detail.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { DropdownTextLimiterPipe } from './pipes/dropdown-text-limiter.pipe'
import { AddLimiterPipe } from './pipes/add-limiter.pipe';
import { EmailRestricterDirective } from './Directives/email-restricter.directive'
import { EmptyStateComponent } from './empty-state/empty-state/empty-state.component'
import { CustomDatePipe } from './pipes/custom-date.pipe'
import { PasswordStrengthBarComponent } from './password-strength-bar/password-strength-bar.component';
import { TextLimiterPipe } from './pipes/text-limiter.pipe'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { CheckSideNavAuthPipe } from './pipes/check-side-nav-auth.pipe';
import { NoWhitespaceDirective } from './Directives/no-whitespace.directive';
import { FilterListPipe } from './pipes/filter-list.pipe';


@NgModule({
  declarations: [HeaderComponent, FooterComponent,
    SideNavComponent, SlotComponent, FilterPipe, FilterMeetingHostPipe, FilterMeetingRoomPipe, FilterListPipe, SlotDetailComponent, TermsConditionComponent, FilterMemberSearchPipe,DropdownTextLimiterPipe,AddLimiterPipe, EmailRestricterDirective,EmptyStateComponent,CustomDatePipe,PasswordStrengthBarComponent, TextLimiterPipe, CheckSideNavAuthPipe, NoWhitespaceDirective],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule
  ],
  exports: [
    HeaderComponent, FooterComponent,
    SideNavComponent, SlotComponent, FilterPipe, FilterMeetingHostPipe, FilterMeetingRoomPipe, FilterListPipe, SlotDetailComponent, FilterMemberSearchPipe,DropdownTextLimiterPipe,AddLimiterPipe,EmailRestricterDirective,EmptyStateComponent,CustomDatePipe,PasswordStrengthBarComponent,TextLimiterPipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
